import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: 'Estimat {{orderMethod}}: {{day}} în jurul orei {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Comandă respinsă',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Comandă primită',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Comanda ta a fost vizualizată',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Comandă confirmată',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Comanda este gata',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Comanda este în curs de livrare',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Comanda este finalizată',
    },
  },
  labels: {
    today: 'Azi',
  },
  waiting_confirmation: {
    title: 'În așteptarea confirmării comenzii',
    description: 'Stai pe fază...',
  },
  pickup_time: {
    title: 'Ora de ridicare',
    description: 'Confirmat de {{name}}',
  },
  delivery_time: {
    title: 'Ora de livrare',
    description: 'Confirmat de {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} a schimbat ora din {{initialTime}} în {{currentTime}}',
  },
};
